import * as React from "react";
interface SvgComponentProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
}
const SvgComponent = (props: SvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    fill={props.fill || "none"}
    {...props}
  >
    <path
      stroke={props.stroke || "#8F8F8F"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M21.167 6.333H2.833m6.667 5V18m5-6.667V18m5-11.667v15.834a.833.833 0 0 1-.833.833H5.333a.833.833 0 0 1-.833-.833V6.333m11.667 0V4.667A1.667 1.667 0 0 0 14.5 3h-5a1.667 1.667 0 0 0-1.667 1.667v1.666"
    />
  </svg>
);
export default SvgComponent;
